module.exports = __webpack_public_path__ + "static/shoe-blue-b16a686dac41818187e7a292806cecd3.png";